module.exports = __webpack_public_path__ + "img/1.309e8d9e.jpg";